(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript && document.currentScript.closest('[data-ec-community]');
  // Multiple sections: scope per section
  document.querySelectorAll('[data-ec-community]').forEach(initCommunity);

  function initCommunity(section){
    if (section.dataset.ecInit) return;
    section.dataset.ecInit = '1';

    const rail = section.querySelector('[data-ec-rail]');
    const drawer = section.querySelector('[data-ec-drawer]');
    const inner = section.querySelector('[data-ec-drawer-inner]');
    const closeBtn = section.querySelector('[data-ec-close]');
    if (!rail || !drawer) return;

    // ===== RANDOM SHUFFLE (client-side, niet in design mode) =====
    if (!window.Shopify || !window.Shopify.designMode){
      const items = Array.from(rail.children);
      for (let i = items.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        rail.appendChild(items[j]);
        items.splice(j, 1);
      }
    }

    // ===== RAIL VIDEO AUTOPLAY (alleen wanneer in beeld, bespaart batterij/data) =====
    const railVideos = rail.querySelectorAll('[data-ec-rail-video]');
    if (railVideos.length){
      // Forceer alle attrs (sommige browsers strippen ze, of theme editor injecteert anders)
      railVideos.forEach(v => {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.loop = true;
      });

      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function'){
          p.catch(() => {
            // Retry na korte delay (iOS soms nodig na load event)
            setTimeout(() => v.play().catch(() => {}), 150);
          });
        }
      };

      if ('IntersectionObserver' in window){
        const io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            const v = entry.target;
            if (entry.isIntersecting){
              if (v.preload === 'none'){
                v.preload = 'auto';
                v.load();
                v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
              } else {
                tryPlay(v);
              }
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.25, rootMargin: '100px' });
        railVideos.forEach(v => io.observe(v));
      } else {
        // Fallback: probeer alle videos direct
        railVideos.forEach(v => { v.preload = 'auto'; v.load(); tryPlay(v); });
      }

      // Mobile fallback: bij eerste user touch ergens op pagina, start alle in-view videos
      // (lost op als battery saver / data saver eerste autoplay blokkeert)
      const unlockOnInteraction = () => {
        railVideos.forEach(v => {
          const rect = v.getBoundingClientRect();
          const inView = rect.top < window.innerHeight && rect.bottom > 0;
          if (inView && v.paused) tryPlay(v);
        });
      };
      document.addEventListener('touchstart', unlockOnInteraction, { once: true, passive: true });
      document.addEventListener('scroll', unlockOnInteraction, { once: true, passive: true });
    }

    // ===== DRAWER OPEN/CLOSE =====
    rail.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-ec-open]');
      if (!trigger) return;
      const id = trigger.dataset.ecOpen;
      const tpl = section.querySelector(`[data-ec-tpl="${CSS.escape(id)}"]`);
      if (!tpl) return;
      inner.replaceChildren(tpl.content.cloneNode(true));
      openDrawer();
      bindDrawer();
    });

    closeBtn?.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) closeDrawer();
    });
    drawer.addEventListener('cancel', (e) => { e.preventDefault(); closeDrawer(); });

    function openDrawer(){
      try { drawer.showModal(); }
      catch(_) { drawer.setAttribute('open',''); }
      document.documentElement.style.overflow = 'hidden';
    }
    function closeDrawer(){
      drawer.classList.add('is-closing');
      setTimeout(() => {
        try { drawer.close(); } catch(_) { drawer.removeAttribute('open'); }
        drawer.classList.remove('is-closing');
        inner.replaceChildren();
        document.documentElement.style.overflow = '';
      }, 280);
    }

    // ===== DRAWER INTERACTIES (dot ↔ kaart highlight, size, add to cart) =====
    function bindDrawer(){
      // Mute toggle (alleen bij video)
      const muteBtn = inner.querySelector('[data-ec-mute]');
      const drawerVideo = inner.querySelector('[data-ec-drawer-video]');
      if (muteBtn && drawerVideo){
        const iconOn = muteBtn.querySelector('.ec-mute-on');
        const iconOff = muteBtn.querySelector('.ec-mute-off');
        muteBtn.addEventListener('click', () => {
          drawerVideo.muted = !drawerVideo.muted;
          if (drawerVideo.muted){
            iconOn.style.display = '';
            iconOff.style.display = 'none';
            muteBtn.setAttribute('aria-label', 'Geluid aan');
          } else {
            iconOn.style.display = 'none';
            iconOff.style.display = '';
            muteBtn.setAttribute('aria-label', 'Geluid uit');
          }
        });
      }
      // Dot → kaart highlight
      inner.querySelectorAll('[data-ec-dot]').forEach(dot => {
        dot.addEventListener('click', () => {
          const handle = dot.dataset.ecDot;
          const card = inner.querySelector(`[data-ec-prod="${CSS.escape(handle)}"]`);
          if (card){
            inner.querySelectorAll('.ec-prod').forEach(c => c.classList.remove('is-highlight'));
            card.classList.add('is-highlight');
            card.scrollIntoView({behavior:'smooth', block:'nearest'});
            setTimeout(() => card.classList.remove('is-highlight'), 1800);
          }
        });
      });

      // Size pickers
      inner.querySelectorAll('.ec-prod__sizes').forEach(group => {
        group.addEventListener('click', (e) => {
          const btn = e.target.closest('.ec-prod__size');
          if (!btn || btn.disabled) return;
          group.querySelectorAll('.ec-prod__size').forEach(b => b.setAttribute('aria-pressed','false'));
          btn.setAttribute('aria-pressed','true');
          const card = btn.closest('.ec-prod');
          const cta = card.querySelector('.ec-prod__cta');
          cta.dataset.variantId = btn.dataset.variantId;
          cta.disabled = false;
        });
      });

      // Add to cart
      inner.querySelectorAll('.ec-prod__cta').forEach(cta => {
        cta.addEventListener('click', async () => {
          const variantId = cta.dataset.variantId;
          const card = cta.closest('.ec-prod');
          const msg = card.querySelector('.ec-prod__msg');
          if (!variantId){
            msg.textContent = 'Kies een maat';
            msg.className = 'ec-prod__msg is-error';
            return;
          }
          cta.classList.add('is-loading');
          cta.disabled = true;
          msg.textContent = '';

          // ===== UGC ATTRIBUTIE TRACKING =====
          // Line item properties met underscore prefix = verborgen voor klant,
          // zichtbaar in Shopify Admin (orders, analytics, exports)
          const creator = inner.querySelector('.ec-drawer__handle')?.textContent.trim() || '';
          const properties = {
            '_source': 'UGC',
            '_attribution': 'Community Section',
            '_section_id': '{{ section.id }}'
          };
          if (creator) properties['_creator'] = creator;

          try {
            const r = await fetch('/cart/add.js', {
              method:'POST',
              headers:{'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({
                items:[{
                  id: Number(variantId),
                  quantity: 1,
                  properties: properties
                }]
              })
            });
            if (!r.ok){
              const err = await r.json().catch(() => ({}));
              throw new Error(err.description || 'Kon niet toevoegen');
            }
            msg.textContent = 'Toegevoegd ✓';
            msg.className = 'ec-prod__msg is-success';
            // Trigger Broadcast cart drawer (zelfde patroon als POP)
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            const cartToggle = document.querySelector('[data-cart-toggle]');
            setTimeout(() => {
              closeDrawer();
              setTimeout(() => cartToggle?.click(), 320);
            }, 600);
          } catch(err){
            msg.textContent = err.message || 'Er ging iets mis';
            msg.className = 'ec-prod__msg is-error';
          } finally {
            cta.classList.remove('is-loading');
            cta.disabled = false;
          }
        });
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stippen-lavalamp"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('stippen-lavalamp')) return;

  var TAU = Math.PI * 2;
  var NB = 4; /* alpha-buckets: batcht duizenden stippen in max. 12 fill-calls */
  var BLOBS = [
    { a: .23, b: .31, p: 0,   q: 1.3, c: 0, k: 1   },
    { a: .17, b: .27, p: 2,   q: .4,  c: 1, k: .8  },
    { a: .29, b: .19, p: 4,   q: 2.6, c: 2, k: .95 },
    { a: .13, b: .23, p: 1,   q: 4,   c: 0, k: .7  },
    { a: .21, b: .15, p: 3.3, q: 5,   c: 2, k: .75 },
    { a: .27, b: .21, p: 5.1, q: .9,  c: 1, k: .65 },
    { a: .11, b: .29, p: 2.7, q: 3.4, c: 0, k: .6  }
  ];
  function ss(a, b, x) { x = Math.min(1, Math.max(0, (x - a) / (b - a))); return x * x * (3 - 2 * x); }
  function backEase(x) { var c1 = 2.2, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); }

  class StippenLavalamp extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._on || !this.isConnected) return;
      this.cv = this.querySelector('.sl__canvas');
      if (!this.cv) return;
      this._on = true;
      this.ctx = this.cv.getContext('2d');
      this.content = this.querySelector('.sl__content');

      var d = this.dataset;
      this.sp = (Number(d.speed) || 10) / 10;
      this.n = Math.min(BLOBS.length, Number(d.blobs) || 5);
      this.bs = (Number(d.blobSize) || 100) / 100;
      this.clear = d.clear === 'true';
      this.mode = d.style || 'pop';
      this.items = [];
      this.rings = [];
      this.timer = 0;
      this.T = 14;
      this.spl = [];
      this.k = 0;
      this.ptr = { on: false, x: 0, y: 0, ex: 0, ey: 0 };
      this.visible = false;
      this.raf = 0;

      this.rm = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mq = window.matchMedia('(min-width: 768px)');
      this.tick = this.tick.bind(this);
      this.toggle = this.toggle.bind(this);
      this.ac = new AbortController();
      var opt = { signal: this.ac.signal };

      this.ro = new ResizeObserver(() => this.resize());
      this.ro.observe(this);
      this.io = new IntersectionObserver((e) => {
        this.visible = e[e.length - 1].isIntersecting;
        this.toggle();
      }, { rootMargin: '120px' });
      this.io.observe(this);

      document.addEventListener('visibilitychange', this.toggle, opt);
      if (this.rm.addEventListener) this.rm.addEventListener('change', this.toggle, opt);

      if (d.interactive === 'true') {
        var pos = (e) => {
          var b = this.getBoundingClientRect();
          this.ptr.x = e.clientX - b.left;
          this.ptr.y = e.clientY - b.top;
        };
        this.addEventListener('pointermove', (e) => {
          if (e.pointerType === 'touch' || this.rm.matches) return;
          if (!this.ptr.on) { pos(e); this.ptr.ex = this.ptr.x; this.ptr.ey = this.ptr.y; }
          this.ptr.on = true;
          pos(e);
        }, opt);
        this.addEventListener('pointerleave', () => { this.ptr.on = false; }, opt);
        this.addEventListener('pointerdown', (e) => {
          if (this.rm.matches || this.spl.length > 5) return;
          pos(e);
          this.k = (this.k + 1) % 3;
          this.spl.push({ x: this.ptr.x, y: this.ptr.y, t: this.T, c: this.k });
        }, opt);
      }
    }

    disconnectedCallback() {
      if (!this._on) return;
      this._on = false;
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.ro.disconnect();
      this.io.disconnect();
      this.ac.abort();
    }

    resize() {
      var cs = getComputedStyle(this);
      this.W = this.clientWidth;
      this.H = this.clientHeight;
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.cv.width = Math.round(this.W * this.dpr);
      this.cv.height = Math.round(this.H * this.dpr);
      this.g = parseFloat(cs.getPropertyValue('--sl-dot')) || 15;
      this.desk = this.mq.matches;
      this.cols = ['--sl-c1', '--sl-c2', '--sl-c3'].map((v) => cs.getPropertyValue(v).trim() || '#000');

      this.zone = null;
      if (this.clear && this.content) {
        var a = this.getBoundingClientRect(), b = this.content.getBoundingClientRect();
        if (b.width) {
          this.zone = {
            x: b.left - a.left + b.width / 2,
            y: b.top - a.top + b.height / 2,
            rx: b.width * .62 + this.g * 1.5,
            ry: b.height * .65 + this.g * 1.5
          };
        }
      }
      if (!this._warm) { this.warm(); this._warm = true; }
      this.draw();
      if (!this.classList.contains('is-ready')) this.classList.add('is-ready');
    }

    /* Simuleert ~4s vooruit zodat de balk direct gevuld is (ook als statisch frame) */
    warm() {
      this.items = [];
      this.rings = [];
      this.timer = 0;
      for (var i = 0; i < 80; i++) { this.T += .05; this.update(.05); }
    }

    update(dt) {
      var W = this.W, H = this.H, T = this.T, R = Math.random, m = this.mode, i, o;
      if (!W || !H) return;
      this.timer -= dt;

      if (m === 'pop') {
        var n = Math.max(3, Math.round(W / (H * .85))), keep = [];
        if (this.items.length < n && this.timer <= 0) {
          this.items.push({ x: R() * W, y: H * (.28 + R() * .44), R: H * (.2 + R() * .28) * this.bs, c: (R() * 3) | 0, b: T, l: 1.6 + R() * 2.2, ph: R() * 6, vx: (R() - .5) * 14 });
          this.timer = .18;
        }
        for (i = 0; i < this.items.length; i++) {
          o = this.items[i];
          o.x += o.vx * dt;
          if (T - o.b > o.l) this.rings.push({ x: o.x, y: o.y, b: T, c: o.c, s: H * 1.3, a: 1, l: .7 });
          else keep.push(o);
        }
        this.items = keep;
      } else if (m === 'drop') {
        if (this.timer <= 0) {
          var x = R() * W, y = H * (.2 + R() * .6), c = (R() * 3) | 0;
          this.items.push({ x: x, y: y, b: T, c: c });
          this.rings.push({ x: x, y: y, b: T, c: c, s: H * 1.5, a: 1.7, l: 1.9 });
          this.timer = Math.min(.9, Math.max(.25, 300 / W));
        }
        this.items = this.items.filter((p) => T - p.b < .5);
      }
      this.rings = this.rings.filter((r) => T - r.b < r.l);
    }

    toggle() {
      var run = this.visible && !document.hidden && !this.rm.matches;
      if (run && !this.raf) {
        this.prev = performance.now();
        this.raf = requestAnimationFrame(this.tick);
      } else if (!run && this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = 0;
      }
      if (this.rm.matches) {
        this.T = 14;
        this.spl.length = 0;
        this.ptr.on = false;
        this.warm();
        this.draw();
      }
    }

    tick(now) {
      var dt = Math.min((now - this.prev) / 1000, .05);
      this.prev = now;
      this.T += dt * this.sp;
      this.update(dt * this.sp);
      this.spl = this.spl.filter((s) => (this.T - s.t) / this.sp < 1.6);
      this.draw();
      this.raf = requestAnimationFrame(this.tick);
    }

    draw() {
      var W = this.W, H = this.H, g = this.g, T = this.T, ctx = this.ctx;
      if (!W || !H) return;

      var base = Math.min(W, H) * (this.desk ? .22 : .26) * this.bs;
      var L = [], i, o, r, a, m = this.mode;
      if (m === 'pop') {
        for (i = 0; i < this.items.length; i++) {
          o = this.items[i];
          a = T - o.b;
          if (a < .55) r = o.R * backEase(Math.min(1, a / .55));
          else if (a > o.l - .32) { var k = (a - (o.l - .32)) / .32; r = o.R * (1 + .35 * Math.sin(k * Math.PI * .5)) * (1 - ss(.45, 1, k)); }
          else r = o.R * (1 + .07 * Math.sin(T * 7 + o.ph));
          if (r > 0) L.push({ x: o.x, y: o.y, r2: r * r, c: o.c });
        }
      } else if (m === 'drop') {
        for (i = 0; i < this.items.length; i++) {
          o = this.items[i];
          r = H * .3 * this.bs * (1 - ss(0, .45, T - o.b));
          if (r > 0) L.push({ x: o.x, y: o.y, r2: r * r, c: o.c });
        }
      } else if (m === 'dans') {
        var nd = Math.max(4, Math.round(W / (H * .75))), cw = W / nd;
        for (i = 0; i < nd; i++) {
          r = H * .3 * this.bs * (.5 + .5 * Math.sin(T * 1.7 + i * 2.1));
          L.push({ x: (i + .5) * cw + Math.sin(T * .6 + i) * cw * .35, y: H * (.5 + .3 * Math.sin(T * 2.2 + i * 1.3)), r2: r * r, c: i % 3 });
        }
      } else {
        for (i = 0; i < this.n; i++) {
          o = BLOBS[i];
          r = base * o.k * (.88 + .12 * Math.sin(T * .7 + o.p));
          L.push({ x: W * (.5 + .44 * Math.sin(T * o.a * 2 + o.p)), y: H * (.5 + .42 * Math.sin(T * o.b * 2 + o.q)), r2: r * r, c: o.c });
        }
      }
      var RG = [], rw = 2 * (g * 1.1) * (g * 1.1);
      for (i = 0; i < this.rings.length; i++) {
        o = this.rings[i];
        a = T - o.b;
        RG.push({ x: o.x, y: o.y, f: a * o.s, a: o.a * (1 - ss(0, o.l, a)), c: o.c });
      }
      var nR = RG.length;
      var p = this.ptr;
      if (p.on) {
        p.ex += (p.x - p.ex) * .12;
        p.ey += (p.y - p.ey) * .12;
        L.push({ x: p.ex, y: p.ey, r2: (base * .55) * (base * .55), c: 1 });
      }
      for (i = 0; i < this.spl.length; i++) {
        var sp = this.spl[i], age = (T - sp.t) / this.sp;
        r = base * 1.15 * ss(0, .45, age) * (1 - ss(.5, 1.5, age));
        if (r > 0) L.push({ x: sp.x, y: sp.y, r2: r * r, c: sp.c });
      }

      var paths = [];
      for (i = 0; i < 3 * NB; i++) paths.push(new Path2D());
      var ox = (W % g) / 2 + g / 2, oy = (H % g) / 2 + g / 2, z = this.zone, nL = L.length;

      for (var y = oy; y < H; y += g) {
        for (var x = ox; x < W; x += g) {
          var F = 0, bv = 0, bc = 0;
          for (var j = 0; j < nL; j++) {
            o = L[j];
            var dx = x - o.x, dy = y - o.y, v = o.r2 / (dx * dx + dy * dy + 1);
            F += v;
            if (v > bv) { bv = v; bc = o.c; }
          }
          for (var q = 0; q < nR; q++) {
            o = RG[q];
            var dd = Math.hypot(x - o.x, y - o.y) - o.f, vr = o.a * Math.exp(-dd * dd / rw);
            F += vr;
            if (vr > bv) { bv = vr; bc = o.c; }
          }
          var s = ss(.25, 1.6, F);
          r = g * (.07 + .56 * s);
          if (z) r *= .1 + .9 * ss(.8, 1.3, Math.hypot((x - z.x) / z.rx, (y - z.y) / z.ry));
          if (r < .4) continue;
          var path = paths[bc * NB + Math.min(NB - 1, (s * NB) | 0)];
          path.moveTo(x + r, y);
          path.arc(x, y, r, 0, TAU);
        }
      }

      ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      for (i = 0; i < paths.length; i++) {
        ctx.globalAlpha = .28 + .72 * (((i % NB) + .5) / NB);
        ctx.fillStyle = this.cols[(i / NB) | 0];
        ctx.fill(paths[i]);
      }
      ctx.globalAlpha = 1;
    }
  }

  customElements.define('stippen-lavalamp', StippenLavalamp);
})();

  } catch(e) { console.error(e); }
})();
})();
